export default "__VITE_ASSET__DAry5bdT__"